<app-success-generico [successGenerico]="alertSucesso" (alertFechou)="fecharAlertSucesso($event)">
</app-success-generico>
<app-loading-generico [loadingGenerico]="alertLoading"></app-loading-generico>
<app-confirma-exclusao [confirmaExclusao]="alertConfirmacao" (confirmaExclusaoFechou)="fecharAlertConfirmacao($event)">
</app-confirma-exclusao>
<app-error-generico [errorGenerico]="alertError" (alertErrorFechou)="fecharAlertError($event)"></app-error-generico>

@if (dadosEnderecoBackup) {
  <div class="row mb-3">
    <div class="col-12">
      <div class="input-group float-end align-items-center w-40">
        <input type="text" class="form-control sombra" [(ngModel)]="campoInput" (keyup.enter)="buscaFiltradaPorInput()"
          placeholder="Buscar endereço">
        <button
          class="btn-icon p-0 border-0 bg-transparent"
          (click)="buscaFiltradaPorInput()"
          (keydown)="buscaFiltradaPorInput()"
          aria-label="Buscar endereço">
          <i class="fa fa-search c-primary icone-lupa" aria-hidden="true"></i>
        </button>
        @if (buscaFiltrada) {
          <button class="botao-outline" (click)="limparFiltro()">LIMPAR FILTRO</button>
        }
      </div>
    </div>
  </div>
}

@if (dadosEndereco && dadosEndereco?.length) {
  <div>
    <div class="row border-top border-bottom pt-3 pb-0">
      <div class="coluna-lapis">
        <span class="label">EDITAR</span>
      </div>
      <div class="coluna-endereco">
        <span class="label">ENDEREÇO</span>
      </div>
      <div class="coluna-lixeira">
        <span class="label">INATIVAR</span>
      </div>
    </div>
    @for (endereco of dadosEndereco | paginate: { id: 'paginacaoEnderecos',
      itemsPerPage: enderecosPorPagina,
      currentPage: paginaEndereco,
      totalItems: $safeNavigationMigration(dadosEndereco?.length) }; track endereco) {
      <div class="row border-top pt-3 pb-0">
        <div class="coluna-lapis">
          <button class="btn pt-0" id="btnEditarEndereco" (click)="editarEndereco(endereco.idEndereco)"
            [disabled]="!('CadastrosDadosDaEmpresa' | usuarioPermissao:'Alterar' | async)">
            <i class="fa fa-pencil c-primary" aria-hidden="true"></i>
          </button>
        </div>
        <div class="coluna-endereco">
          <p class="paragrafo">{{endereco.fullDescription | camelCase}}</p>
        </div>
        <div class="coluna-lixeira">
          <button class="btn pt-0" id="btnInativarEndereco" (click)="confirmaInativacao(endereco.idEndereco)" title="Inativar endereço"
            [disabled]="!('CadastrosDadosDaEmpresa' | usuarioPermissao:'Excluir' | async)">
            <i class="fa fa-ban c-primary" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    }
  </div>
}

<!-- FOOTER-CARD - PAGINAÇÃO - EMPRESAS -->
@if (dadosEndereco && dadosEndereco?.length) {
  <div class="footer-card">
    <div>
      <app-select
        [value]="enderecosPorPagina"
        (valueChanges)="onEnderecosPorPaginaChange($event)"
        name="enderecosPorPaginaName"
    [options]="[
    {name : 'Exibir 3 endereços' , value : '3'} ,
    {name : 'Exibir 6 endereços' , value : '6'} ,
    {name : 'Exibir 9 endereços' , value : '9'}

    ]"
        optionValue="value"
        optionText="name">
      </app-select>
    </div>
    <!-- Paginação CENTRAL -->
    <div>
      <pagination-controls class="my-pagination" id="paginacaoEnderecos" directionLink="true"
        (pageChange)="paginaEndereco = $event" responsive="true" previousLabel="Anterior" nextLabel="Próxima">
      </pagination-controls>
    </div>
    <div>
      <p><span class="itens-pagina">{{dadosEndereco.length}}</span> Registros foram encontrados</p>
    </div>
  </div>
}
@if (dadosEndereco && dadosEndereco?.length) {
  <div class="d-flex container-fluid justify-content-center m-0 p-0 mt-5">
    <button class="botao-outline botao-ajuste me-1" id="btnInativos" routerLink="/enderecos-inativos">INATIVOS</button>
    <button class="botao px-5" id="btnNovoEndereco" routerLink="/adicionar-endereco"
    [disabled]="!('CadastrosDadosDaEmpresa' | usuarioPermissao:'Incluir' | async)">NOVO</button>
  </div>
}
<!-- CARREGAMENTO EMPRESAS -->
@if (dadosEndereco === null) {
  <div>
    <div class="text-center">
      <output class="spinner-border c-primary">
        <span class="visually-hidden">Consultando endereços da empresa ...</span>
      </output>
    </div>
    <p class="legenda-spinner">Consultando endereços da empresa ...</p>
  </div>
}

<!-- CASO DE ERRO EMPRESAS -->
@if (dadosEndereco === false) {
  <div class="text-center">
    <img src="/assets/img/erro.png" width="200px" alt="Erro">
    <p class="legenda-erro">Ocorreu um erro na consulta de endereços da empresa.</p>
  </div>
}

<!-- CASO DE ESTEJA VAZIO -->
@if (!dadosEndereco?.length && dadosEndereco !== null) {
  <div class="text-center">
    <img src="/assets/img/vazio.png" width="230px" alt="Erro">
    <p class="legenda-vazio">Não existem endereços para essa consulta.</p>
    <div class="d-flex container-fluid justify-content-center m-0 p-0 mt-5">
      <button class="botao px-5" [disabled]="!('CadastrosDadosDaEmpresa' | usuarioPermissao:'Incluir' | async)" routerLink="/adicionar-endereco">NOVO</button>
    </div>
  </div>
}
